import { render, staticRenderFns } from "./CustomerDetail3.vue?vue&type=template&id=0ef24b2f&scoped=true"
import script from "./CustomerDetail3.vue?vue&type=script&lang=js"
export * from "./CustomerDetail3.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetail3.vue?vue&type=style&index=0&id=0ef24b2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef24b2f",
  null
  
)

export default component.exports